import { Box, Card, CardHeader, Notification, Typography } from '@packages/shared';
import React from 'react';
import { CardContent } from '@mui/material';
import { basicContainer, styleCardHeader, styleContentTop, stylePanel } from '../styles';
import { FormFooterArea } from '../FormFooterAreaV2';
import { ActivityOverlay } from '../ActivityOverlay';

export const GeneralFormWrapper = ({
  headingArea,
  isSubmitting,
  isValid,
  submitButton,
  submitHandler,
  formHeading,
  children,
  handleOnClose,
  errorNotification,
}: {
  headingArea?: {
    headline: string;
    description: string | JSX.Element | (string | JSX.Element)[];
  };
  isSubmitting: boolean;
  isValid: boolean;
  submitButton: { enabled: string; disabled: string };
  submitHandler: (e?: React.BaseSyntheticEvent<object> | undefined) => Promise<void>;
  formHeading?: string;
  children: React.ReactNode;
  handleOnClose: () => void;
  errorNotification: { show: boolean; message: string };
}) => (
  <ActivityOverlay showLoader={isSubmitting}>
    <Notification
      open={errorNotification.show}
      severity="error"
      autoHideDuration={3500}
      onClose={handleOnClose}
    >
      {errorNotification.message}
    </Notification>
    {headingArea && (
      <Box sx={styleContentTop}>
        <Typography variant="h3" component="div" sx={{ marginBottom: 2.25 }}>
          {headingArea.headline}
        </Typography>
        {headingArea.description}
      </Box>
    )}
    <form noValidate onSubmit={submitHandler} name="generalForm">
      <Box sx={stylePanel}>
        <Card sx={basicContainer}>
          {formHeading && <CardHeader title={formHeading} sx={styleCardHeader} />}

          <CardContent sx={{ padding: 4 }}>{children}</CardContent>
        </Card>
      </Box>
      <FormFooterArea isValid={isValid} submitButton={submitButton} />
    </form>
  </ActivityOverlay>
);
